import React from 'react';
import { Box, BoxProps, Flex, Link as ChakraLink, SimpleGrid, Text } from '@chakra-ui/react';
import { FaStar } from 'react-icons/fa';
import { IoIosArrowDropright, IoMdCard } from 'react-icons/io';
import { PiBankLight } from 'react-icons/pi';
import { Branch } from '../../../domain/branch';
import { Link as RouterLink } from 'react-router-dom';
import { SimpleDescription } from '../../../components/SimpleDescription';
import { paymentMethodToString } from '../../../domain/payment-method';
import { planToString } from '../../../domain/payment-plan';

interface BranchCardProps extends BoxProps {
  branch: Branch;
}

export function BranchCard(props: BranchCardProps) {
  const { branch, ...boxProps } = props;

  return (
    <Box
      key={branch.id}
      borderWidth="1px"
      borderColor="neutral.200"
      borderRadius="xl"
      padding="xxl"
      {...boxProps}
    >
      <Flex alignItems="center" justifyContent="space-between" marginBottom="xl">
        <FaStar color="orange" />
        <Text
          marginLeft="l"
          fontSize="l"
          fontWeight="medium"
          textTransform="capitalize"
        >
          {branch.fantasy_name}
        </Text>
        <ChakraLink as={RouterLink} marginLeft="auto" to={'branches/' + branch.id} color="primary.800">
          <Flex alignItems="center">
            <Text marginRight="l">Ver detalles</Text>
            <IoIosArrowDropright />
          </Flex>
        </ChakraLink>
      </Flex>

      <SimpleGrid columns={2} spacing={2}>
        <SimpleDescription label="ID Comercio" description={branch.merchant_info.identifier?.toString()} />
        <SimpleDescription label="ID Sucursal" description={branch.identifier?.toString()} />
        <SimpleDescription label="Comercio" description={branch.merchant_info.business_name || 'No disponible'} />
        <SimpleDescription label="Teléfono" description={branch.phone || 'No disponible'} />
        {/*<SimpleDescription label="Email" description={branch.description || 'No disponible'} />*/}
      </SimpleGrid>

      <Flex alignItems="center" marginTop="xl">
        <IoMdCard />
        <Text marginLeft="l" fontWeight="medium">Condiciones comerciales</Text>
      </Flex>

      <Flex alignItems="center" justifyContent="space-between" flexWrap="wrap" marginTop="l">
        {branch.payment_plans?.slice(0,3).map((plan) => (
          <SimpleDescription marginRight="xxxl" _firstLetter={{ textTransform: "uppercase" }} key={plan.id}
            label={paymentMethodToString(plan.payment_method)}
            description={plan.card_brand + ', ' + (planToString(plan) || 'No disponible')} />
        ))}
      </Flex>

      <Flex alignItems="center" marginTop="xxl">
        <PiBankLight />
        <Text marginLeft="l">Cuenta Bancaria</Text>
      </Flex>

      <Flex justifyContent="space-between" marginTop="xl">
        <SimpleDescription label="Alias para CLABE" description={branch.account_alias || 'No disponible'} />
        <SimpleDescription label="#CLABE" description={branch.cbu_or_cvu || 'No disponible'} />
      </Flex>
    </Box>

  );
}
